var _path, _path2, _rect, _path3, _path4, _path5, _path6, _path7, _path8;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgSavecontact = function SvgSavecontact(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 43,
    height: 39,
    viewBox: "0 0 43 39",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.32 1H8.68C5.99175 1 4.64762 1 3.62085 1.52317C2.71767 1.98336 1.98336 2.71767 1.52317 3.62085C1 4.64762 1 5.99175 1 8.68V25.32C1 28.0083 1 29.3524 1.52317 30.3792C1.98336 31.2823 2.71767 32.0166 3.62085 32.4768C3.80213 32.5692 3.99331 32.6453 4.20004 32.7079C5.16416 33 6.46639 33 8.68 33H25.32C27.5336 33 28.8358 33 29.8 32.7079C30.0067 32.6453 30.1979 32.5692 30.3792 32.4768C31.2823 32.0166 32.0166 31.2823 32.4768 30.3792C33 29.3524 33 28.0083 33 25.32V8.68C33 5.99175 33 4.64762 32.4768 3.62085C32.0166 2.71767 31.2823 1.98336 30.3792 1.52317C29.3524 1 28.0083 1 25.32 1Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M29.677 30.1514C29.7917 30.7278 29.7994 31.413 29.8 32.7079M29.8 32.7079C28.8358 33 27.5336 33 25.32 33H8.68C6.46639 33 5.16416 33 4.20004 32.7079C3.99331 32.6453 3.80213 32.5692 3.62085 32.4768C2.71767 32.0166 1.98336 31.2823 1.52317 30.3792C1 29.3524 1 28.0083 1 25.32V8.68C1 5.99175 1 4.64762 1.52317 3.62085C1.98336 2.71767 2.71767 1.98336 3.62085 1.52317C4.64762 1 5.99175 1 8.68 1H25.32C28.0083 1 29.3524 1 30.3792 1.52317C31.2823 1.98336 32.0166 2.71767 32.4768 3.62085C33 4.64762 33 5.99175 33 8.68V25.32C33 28.0083 33 29.3524 32.4768 30.3792C32.0166 31.2823 31.2823 32.0166 30.3792 32.4768C30.1979 32.5692 30.0067 32.6453 29.8 32.7079Z",
    stroke: "var(--hyperlink )",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 22,
    y: 27,
    width: 15,
    height: 9,
    fill: "#F4F5F7"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17 20C14.3448 20 11.9835 21.2755 10.4802 23.255C10.1566 23.681 9.99483 23.894 10.0001 24.1819C10.0042 24.4043 10.1446 24.6849 10.3205 24.8222C10.5482 25 10.8637 25 11.4947 25H22.5053C23.1363 25 23.4518 25 23.6795 24.8222C23.8554 24.6849 23.9958 24.4043 23.9999 24.1819C24.0052 23.894 23.8434 23.681 23.5198 23.255C22.0165 21.2755 19.6552 20 17 20Z",
    fill: "var(--hyperlink )"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17 17.5C19.0817 17.5 20.7692 15.8211 20.7692 13.75C20.7692 11.6789 19.0817 10 17 10C14.9183 10 13.2308 11.6789 13.2308 13.75C13.2308 15.8211 14.9183 17.5 17 17.5Z",
    fill: "var(--hyperlink )"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M17 20C14.3448 20 11.9835 21.2755 10.4802 23.255C10.1566 23.681 9.99483 23.894 10.0001 24.1819C10.0042 24.4043 10.1446 24.6849 10.3205 24.8222C10.5482 25 10.8637 25 11.4947 25H22.5053C23.1363 25 23.4518 25 23.6795 24.8222C23.8554 24.6849 23.9958 24.4043 23.9999 24.1819C24.0052 23.894 23.8434 23.681 23.5198 23.255C22.0165 21.2755 19.6552 20 17 20Z",
    stroke: "var(--hyperlink )",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M17 17.5C19.0817 17.5 20.7692 15.8211 20.7692 13.75C20.7692 11.6789 19.0817 10 17 10C14.9183 10 13.2308 11.6789 13.2308 13.75C13.2308 15.8211 14.9183 17.5 17 17.5Z",
    stroke: "var(--hyperlink )",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M39 30L39 31C39 32.4001 39 33.1002 38.7275 33.635C38.4878 34.1054 38.1054 34.4878 37.635 34.7275C37.1002 35 36.4001 35 35 35L28 35C26.5999 35 25.8998 35 25.365 34.7275C24.8946 34.4878 24.5122 34.1054 24.2725 33.635C24 33.1002 24 32.4001 24 31L24 30M35.6667 25.8333L31.5 30M31.5 30L27.3333 25.8333M31.5 30L31.5 20",
    stroke: "white",
    strokeWidth: 8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M39 30L39 31C39 32.4001 39 33.1002 38.7275 33.635C38.4878 34.1054 38.1054 34.4878 37.635 34.7275C37.1002 35 36.4001 35 35 35L28 35C26.5999 35 25.8998 35 25.365 34.7275C24.8946 34.4878 24.5122 34.1054 24.2725 33.635C24 33.1002 24 32.4001 24 31L24 30M35.6667 25.8333L31.5 30M31.5 30L27.3333 25.8333M31.5 30L31.5 20",
    stroke: "var(--hyperlink )",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgSavecontact, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/savecontact.0f902910.svg";
export { ForwardRef as ReactComponent };